module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img_3.37423971.png";